import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getWorkByTitle } from '../redux/actions/dataActions';
import Link from "react-router-dom/Link";

import './WorkItemDetail.css';

class WorkItemDetail extends Component {

    componentDidMount(){
        const title = this.props.match.params.title;
        this.props.getWorkByTitle(title);
    }

    handleClose = () => {
        this.props.history.push('/work'); // Navigate back to work grid
    }

    render() {

        const { data: { work }} = this.props;

        let workMarkup = work ? 
        <div className="WorkItemContent">
            <button className="closeButton" onClick={this.handleClose}>X</button>
            <div className="workItemImageContainer">
              <img src={work.image} alt="" />
            </div>
            <div className="WorkItemContentText">
              <Typography variant="h3">{work.title}</Typography>
              <Typography variant="h6">{work.text}</Typography>
              <a href="/work/TrackBill/privacy" target="_blank" rel="noopener noreferrer">
                <Typography variant="h6">Datenschutzerklärung</Typography>
              </a>
            </div>
          </div> 
          : <p color="white">Loading ... </p>;

        return (
            <div>
                <div color="white">{workMarkup}</div>
            </div>
        );
    }
}

WorkItemDetail.propTypes = {
    classes: PropTypes.object.isRequired,
    getWorkByTitle: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  };

const mapStateToProps = (state) => ({
    data: state.data
});

const mapActionsToProps = {
    getWorkByTitle
};

export default connect(mapStateToProps, mapActionsToProps)(WorkItemDetail);
